<div class="input-wrapper">
  <div class="suffix">
    <ui-icon [nameIcon]="passwordVisible ? 'visibility' : 'visibility_off'"   (click)="passwordVisible = !passwordVisible"></ui-icon>
  </div>
  <input
    autocomplete="off"
    [formControl]="formControl"
    [type]="passwordVisible ? 'text' : 'password'"
    nz-input
    [placeholder]="placeholder"
    [textMask]="{
              mask: passwordMask,
              guide: false,
              keepCharPositions: false
            }"
  />
</div>
<ng-container *ngIf="formControl.errors && formControl.touched">
  <div class="errors" *ngIf="formControl.errors && formControl.errors.required">
    <div class="error">Обязательное поле</div>
  </div>
  <div class="errors" *ngIf="formControl.errors && formControl.errors?.passwordConfirm">
    <div class="error">Пароли не совпадают</div>
  </div>
</ng-container>

